import { useEffect } from "react";

export default function useReveal() {
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) entry.target.classList.add("in");
                });
            },
            { threshold: 0.12 },
        );

        document
            .querySelectorAll(".reveal")
            .forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);
}
